import { NgModule } from '@angular/core';
import { asmTranslationChunksConfig, asmTranslationsCs } from "@spartacus/asm/assets";
import { AsmRootModule, ASM_FEATURE } from "@spartacus/asm/root";
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";

@NgModule({
  declarations: [],
  imports: [
    AsmRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [ASM_FEATURE]: {
        module: () =>
          import('@spartacus/asm').then((m) => m.AsmModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: asmTranslationsCs,
      chunks: asmTranslationChunksConfig,
    },
  })
  ]
})
export class AsmFeatureModule { }
